export class AssetViewerViewMapper {
    static mapToPublicAssetViewerView(assetViewerView) {
        return {
            id: assetViewerView.id,
            page: assetViewerView.page,
            renderState: assetViewerView.renderState,
            previewRenderState: assetViewerView.previewRenderState,
            getAnnotationHelper: () => assetViewerView.getAnnotationHelper(),
            getAnnotations: () => assetViewerView.getAnnotations(),
            didAnnotationsChange: () => assetViewerView.didAnnotationsChange(),
            enableAnnotations: () => assetViewerView.enableAnnotations(),
            disableAnnotations: () => assetViewerView.disableAnnotations(),
            assetViewerItem: assetViewerView.assetViewerItem
        };
    }
}
//# sourceMappingURL=AssetViewerViewMapper.js.map